import { CONFIRMATION_MODE, DISPLAY_DATETIME_FORMAT } from '../constants';
import moment from '../moment/moment';
import { getReservationFullName } from './reservations';


export const CANCELLED_RESERVATION = "CANCELLED_RESERVATION";
export const NEW_RESERVATION = "NEW_RESERVATION";
export const NEW_SYNC_RESERVATION = "NEW_SYNC_RESERVATION";
export const CANCELLED_BY_CUSTOMER = "CANCELLED_BY_CUSTOMER";
export const MODIFIED_BY_CUSTOMER = "MODIFIED_BY_CUSTOMER";
export const MUST_REASSIGN_TABLES_RESERVATION = "MUST_REASSIGN_TABLES_RESERVATION";

export const NOTIFICATIONS_TYPES_ICONS = {
    [CANCELLED_RESERVATION]: { name: "delete calendar", color: 'red', },
    [CANCELLED_BY_CUSTOMER]: { name: "delete calendar", color: 'red', },
    [NEW_RESERVATION]: { name: "clock", color: 'orange', },
    [NEW_SYNC_RESERVATION]: { name: "check", color: 'green', },
    [MODIFIED_BY_CUSTOMER]: { name: "edit", color: 'orange', },
    [MUST_REASSIGN_TABLES_RESERVATION]: { name: "attention", color: "red", },
    default: { name: 'clock', color: 'orange', },
}

export const getNotificationAgo = (notification) => moment(notification.updated_at).fromNow();

export const isMustReassignTablesReservation = r => !r.cancelled && r.confirmed && r.tables.length == 0 && MUST_REASSIGN_TABLES_RESERVATION;
export const isReservationCancelled = r => r.cancelled && r.cancelled_by === CANCELLED_BY_CUSTOMER && CANCELLED_RESERVATION;
export const isNewAsyncReservation = r => !r.cancelled && r.confirmation_mode === CONFIRMATION_MODE.CONFIRMATION_MODE_ASYNCHRONOUS && !r.confirmed && NEW_RESERVATION;
export const isNewSyncReservation = r => !r.cancelled && r.confirmation_mode === CONFIRMATION_MODE.CONFIRMATION_MODE_SYNCHRONOUS && NEW_SYNC_RESERVATION;
export const isModifiedReservation = r => !r.cancelled && r.confirmed && r.tables.length > 0 && r.modified && MODIFIED_BY_CUSTOMER;
export const isRecentReservation = ({ start_time }) => moment(start_time).isSameOrAfter(moment().startOf('day'));
export const getReservationRelevance = (r) => !r.read && isRecentReservation(r) && (isReservationCancelled(r) || isModifiedReservation(r) || isMustReassignTablesReservation(r) || isNewAsyncReservation(r) || isNewSyncReservation(r));

export const getNotifications = (reservations, orders) => {
    const relevantOrders = orders.filter(order => !order.read && moment(order.shift_from_datetime) >= moment());

    const relevantReservations = reservations.filter(getReservationRelevance);

    const augmentedReservations = relevantReservations.map(
        reservation => {
            const notificationType = getReservationRelevance(reservation);
            const { name, color } = NOTIFICATIONS_TYPES_ICONS[notificationType] ?? NOTIFICATIONS_TYPES_ICONS.default;
            return {
                ...reservation,
                notificationEventType: "RESERVATION",
                notificationEventDatetime: moment(reservation.start_time),
                notificationType,
                notificationLogo: name,
                notificationColor: color,
                notificationAgo: getNotificationAgo(reservation),
                notificationFullName: getReservationFullName(reservation),
                notificationStartTime: moment(reservation.start_time).format(DISPLAY_DATETIME_FORMAT),
                notificationGuestsDetails: ""
            }
        }
    );

    const augmentedOrders = relevantOrders.map(
        order => (
            {
                ...order,
                notificationEventType: "ORDER",
                notificationEventDatetime: moment(order.shift_from_datetime),
                notificationAgo: getNotificationAgo(order),
                notificationFullName: order.first_name + ' ' + order.last_name,
                notificationStartTime: moment(order.shift_from_datetime).format(DISPLAY_DATETIME_FORMAT),
            }
        )
    );
    const notifications = augmentedReservations
        .concat(augmentedOrders)
        .sort((a, b) => moment(a.notificationEventDatetime) - moment(b.notificationEventDatetime));

    const synchronousReservationCount = augmentedReservations.filter(
        r =>
            r.confirmation_mode === CONFIRMATION_MODE.CONFIRMATION_MODE_SYNCHRONOUS &&
            r.tables.length > 0 &&
            !(r.should_be_called && !r.has_been_called)
    ).length;
    return { notifications, synchronousReservationCount };
};


// WEBPACK FOOTER //
// ./src/helpers/notifications.js